"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AverageNcdTable = exports.NcdStepbackTable = exports.NcdInfoSection = void 0;
var React = require("react");
var NcdInfoSection = function () {
    var _a = React.useState("4"), ncdYears = _a[0], setNcdYears = _a[1];
    var options = [];
    var ncdYearsMap = new Map([
        ["4", "4 years of NCD"],
        ["5", "5-8 years of NCD"],
        ["9", "9+ years of NCD"]
    ]);
    ncdYearsMap.forEach(function (value, key) {
        options.push(React.createElement("option", { key: key, value: key }, value));
    });
    return (React.createElement("div", { className: "ncd-info-section" },
        React.createElement("p", { className: "mb-2 font-weight-extra-light" }, "No claim discount (NCD) protection means you won\u2019t lose your NCD no matter how many claims you make. This protects your NCD but your price may still increase if you\u2019ve made a claim."),
        React.createElement("div", { className: "mb-2" },
            React.createElement("p", { className: "mb-0 font-weight-semi-bold ncd-section-title" }, "Without protected NCD"),
            React.createElement("p", { className: "mb-0 font-weight-extra-light pncd-dropdown-section" },
                React.createElement("span", null, "If you have"),
                React.createElement("select", { id: "pncd-years", className: "form-control inline-control m-2", onChange: function (e) { return setNcdYears(e.target.value); }, value: ncdYears }, options),
                React.createElement("span", null, "and you make a claim, your NCD at renewal will reduce to...")),
            React.createElement(exports.NcdStepbackTable, { ncdYears: ncdYears }),
            React.createElement("div", { className: "light-blue-panel" },
                React.createElement("p", null,
                    React.createElement("span", { className: "font-weight-bold" }, "With protected NCD "),
                    "there's no reduction to your NCD at renewal, no matter how many claims you make.")),
            React.createElement("p", { className: "mb-0 font-weight-semi-bold mt-3" }, "Average NCD"),
            React.createElement("p", { className: "mb-0 font-weight-extra-light" }, "View how your No Claim Discount (NCD) grows over time."),
            React.createElement(exports.AverageNcdTable, null))));
};
exports.NcdInfoSection = NcdInfoSection;
var NcdStepbackTable = function (_a) {
    var ncdYears = _a.ncdYears;
    var tableRows = [];
    var ncdStepbackTriple = [
        { ncdYears: "4", numberOfClaims: "1 claims", ncdAtRenewal: "2 years" },
        { ncdYears: "4", numberOfClaims: "2 claims", ncdAtRenewal: "0 years" },
        { ncdYears: "4", numberOfClaims: "3 claims", ncdAtRenewal: "0 years" },
        { ncdYears: "5", numberOfClaims: "1 claims", ncdAtRenewal: "3 years" },
        { ncdYears: "5", numberOfClaims: "2 claims", ncdAtRenewal: "1 years" },
        { ncdYears: "5", numberOfClaims: "3 claims", ncdAtRenewal: "0 years" },
        { ncdYears: "9", numberOfClaims: "1 claims", ncdAtRenewal: "4 years" },
        { ncdYears: "9", numberOfClaims: "2 claims", ncdAtRenewal: "2 years" },
        { ncdYears: "9", numberOfClaims: "3 claims", ncdAtRenewal: "0 years" }
    ];
    ncdStepbackTriple.filter(function (s) { return s.ncdYears === ncdYears; }).forEach(function (value) {
        tableRows.push(React.createElement("tr", null,
            React.createElement("td", null, value.numberOfClaims),
            React.createElement("td", { className: "font-weight-semi-bold" }, value.ncdAtRenewal)));
    });
    return (React.createElement("table", { className: "table table-striped ncd-table" },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { scope: "col" }, "Number of claims"),
                React.createElement("th", { scope: "col" }, "NCD at renewal"))),
        React.createElement("tbody", null, tableRows)));
};
exports.NcdStepbackTable = NcdStepbackTable;
var AverageNcdTable = function () {
    var tableRows = [];
    var averageNcdMap = new Map([
        ["1", "55%"],
        ["2", "57%"],
        ["3", "61%"],
        ["4", "63%"],
        ["5", "64%"],
        ["6", "65%"],
        ["7", "67%"],
        ["8", "68%"],
        ["9 or more", "70%"]
    ]);
    averageNcdMap.forEach(function (value, key) {
        tableRows.push(React.createElement("tr", null,
            React.createElement("td", null, key),
            React.createElement("td", { className: "font-weight-semi-bold" }, value)));
    });
    return (React.createElement("table", { className: "table table-striped ncd-table" },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { scope: "col" }, "NCD years"),
                React.createElement("th", { scope: "col" }, "Average NCD discount"))),
        React.createElement("tbody", null, tableRows)));
};
exports.AverageNcdTable = AverageNcdTable;
//# sourceMappingURL=NcdInfoSection.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/optionalExtras/NcdInfoSection.js
// module id = 729
// module chunks = 0